function removeBriefItemSuffix(value: string): string {
  const suffix = 'BriefItem';
  if (value.endsWith(suffix)) {
    return value.slice(0, -suffix.length);
  }
  return value;
}

export default removeBriefItemSuffix;
